import React, { FC, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';
import withLocalization from '../hoc/withLocalization';
import { useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import {
  setPinOptFlowLeadInfo,
  setLeadInfoCheckBox,
  setOfferFlowDetails,
  addOptinPinDetailsRequest,
} from '../../features/PinOptLeadInfoContainer/PinOptFlowOfferSlice';
import { logAnalyticData, offerType } from '../../analytics';
import { Offer, OfferResponse } from '../../features/offerSearch/types';
import './LeadInfoDetails.scss';
import { generateCorrelationId } from '../../util/CommonLogic';
import { loadOfferDetails } from '../../features/offerSearch/offerSearchSlice';

interface SearchPanelProps {
  localize?: any;
  history: any;
  isValidForm: boolean;
  isEdit: boolean;
  email?: any;
  phone?: any;
  ischecked: boolean;
  leadDetails: any;
}
const LeadSubmitBtn: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, history, isValidForm, isEdit, email, phone, ischecked, leadDetails } = props;
  const dispatch = useDispatch();
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  // const allDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails);
  const offerDetails: OfferResponse = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const isSubmitErr = useSelector((state: RootState) => state.offerDetails.hasError);
  const submitError = useSelector((state: RootState) => (isSubmitErr ? state.offerDetails.error?.errorMessageKey : ''));
  const callCenterPhone: any = useSelector((state: RootState) => state.offerDetails.nonFormatedCallcenterNo);
  const mailingData: any = useSelector((state: RootState) => state.newOfferPaymentDetails.mailingAddressInfo);
  const offer: Offer = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const offerCode = offer?.offerCode || 'Vacation Offer';
  const errPhNo = { errPhNo: callCenterPhone || '' };
  const [submitClicked, setSubmitClicked] = React.useState(false);

  useEffect(() => {
    if (submitClicked && offerDetails?.offers && offerDetails?.offers?.length > 0) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      history.push('/payment' + getUrlSearchParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerDetails, submitClicked]);

  const handleClickBackToLandingPage = () => {
    history.push('/pin-error', errPhNo);
    window.dataLayer.push({
      event: 'wrong-info',
    });
    logAnalyticData(
      {
        event: 'pbePinWrongInformation',
        siteSection: 'MVC Optimized PBE',
        pageName: 'MVC PBE Verify Page',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        errorMessage: submitError,
        offerCode: offerCode,
        offerType: offerType(offer),
        flowldentifier: 'PIN',
        bookingStepName: 'MVC | PBE Verify Page',
      },
      {
        linkName: 'PBE PIN Wrong Information',
        linkClickPage: 'MVC PBE Verify Page',
      },
    );
  };
  useEffect(() => {
    if (isSubmitErr) {
      history.push('/pin-error', errPhNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitErr]);

  const optinDetailMapping = () => {
    const addr = leadDetails?.addressLine1 ? '' : mailingData?.address;
    const custCity = leadDetails?.city ? '' : mailingData?.city;
    const custZip = leadDetails?.postalCode ? '' : mailingData?.zipCode;
    const custState = leadDetails?.stateProvince ? '' : mailingData?.stateCode;
    const chkFlag = ischecked ? 'Y' : 'N';
    const mapData: any = {
      pin: pinInfoDetails?.pin || '',
      optInMail: chkFlag,
      optInEmail: chkFlag,
      optInText: chkFlag,
      optInPhone: chkFlag,
      customerEmail: email || '',
      customerPhone: phone || '',
      customerAddress: addr || '',
      customerCity: custCity || '',
      customerState: custState || '',
      customerCountry: '',
      customerZipcode: custZip || '',
    };
    return mapData;
  };
  const handleClickLeadSubmitBtn = () => {
    if (isValidForm) {
      const correlationId = generateCorrelationId();
      const optinPayload = optinDetailMapping();
      dispatch(addOptinPinDetailsRequest({ ...optinPayload, correlationId }, correlationId));
      if (isEdit) {
        dispatch(setPinOptFlowLeadInfo({ email, phone }));
      }
      dispatch(setOfferFlowDetails(true));
      dispatch(setLeadInfoCheckBox(ischecked));
      setSubmitClicked(true);
      dispatch(loadOfferDetails(pinInfoDetails?.pin, pinInfoDetails?.lastName, 'y', true));
      //history.push('/payment' + getUrlSearchParam);
      window.dataLayer.push({
        event: 'pin-verify',
      });
      logAnalyticData(
        {
          event: 'pbePinVerify',
          siteSection: 'MVC Optimized PBE',
          pageName: 'MVC PBE Verify Page',
          pageHierarchy: '',
          server: 'MVC',
          website: 'MVC react',
          language: 'en',
        },
        {
          errorMessage: submitError,
          offerCode: offerCode,
          offerType: offerType(offer),
          flowldentifier: 'PIN',
          bookingStepName: 'MVC | PBE Verify Page',
        },
        {
          linkName: 'PBE PIN Verify',
          linkClickPage: 'MVC PBE Verify Page',
        },
      );
    }
  };

  return (
    <>
      <div className="leadInfo-btn-container">
        <button
          className={isValidForm ? 'myInfo-btn-enable' : 'myInfo-btn-disable'}
          onClick={() => handleClickLeadSubmitBtn()}
        >
          {localize('preview-sales-engine.static-content.copy.pbeo.yes-my-info-cta-label')}
        </button>
        <button className="notMyInfo-btn" onClick={() => handleClickBackToLandingPage()}>
          {localize('preview-sales-engine.static-content.copy.pbeo.not-my-info-cta-label')}
        </button>
      </div>
    </>
  );
};
export default withRouter(withLocalization(LeadSubmitBtn));
